import { render, staticRenderFns } from "./ElectronicUploadErrorBanner.vue?vue&type=template&id=d221802a&scoped=true&"
import script from "./ElectronicUploadErrorBanner.vue?vue&type=script&lang=js&"
export * from "./ElectronicUploadErrorBanner.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicUploadErrorBanner.vue?vue&type=style&index=0&id=d221802a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d221802a",
  null
  
)

export default component.exports